import { IGLAccount, IGLAccountData } from '../accounting.types';
import { GLAccount } from '../accounting';

export const mockGLAccountsData = (): IGLAccountData[] => [
  {
    id: 1,
    code: '123456',
    name: 'Cash',
    departments: [
      {
        id: 1,
        code: '001',
        name: 'HR'
      }
    ]
  },
  {
    id: 2,
    code: '654321',
    name: 'Accounts Receivable',
    departments: [
      {
        id: 2,
        code: '002',
        name: 'Engineering'
      }
    ]
  }
];

export const mockGLAccounts = (
  data: IGLAccountData[] = mockGLAccountsData()
): IGLAccount[] => data.map(item => new GLAccount(item));
